import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomArrowUp = (props: SvgIconProps): JSX.Element => {
    return (
        <SvgIcon {...props}>
            <path d="M12 3L19.5 10.6154L17.75 12.3923L13.25 7.82308L13.25 21L10.75 21L10.75 7.82308L6.25 12.3923L4.5 10.6154L12 3Z" />
        </SvgIcon>
    );
};
